import {useQuery} from '@tanstack/react-query';
import {useBusiness} from '../contexts/BusinessContext';
import {getBusinessFeaturePlan} from '../lib/billing/businessFeatureService';

export function usePlanAccess() {
  const {userId, activeBusiness, activeAccess} = useBusiness();
  const accountantMode = activeAccess?.mode === 'accountant';
  const planQuery = useQuery({
    queryKey: ['business-feature-plan', userId, activeBusiness?.id],
    queryFn: () => getBusinessFeaturePlan(activeBusiness.id),
    enabled: Boolean(userId && activeBusiness?.id && !accountantMode),
    staleTime: 60_000
  });

  const planType = accountantMode ? null : planQuery.data || null;

  return {
    ...planQuery,
    planType,
    isPlanResolved: accountantMode || planQuery.isSuccess,
    isPlanUnavailable: !accountantMode && planQuery.isError,
    isMileagePlan: !accountantMode && planType === 'mileage'
  };
}
